module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestRemoval()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container-fluid spinner-container"
  }, [_vm._m(1)]) : (_vm.validToken) ? _c('div', {
    staticClass: "content text-bold h5",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v("Please take note of the following process applicable to the deletion of your profile:")]), _vm._v(" "), _c('p', [_vm._v("The HPCSA guidelines states that “Health records should be stored for a period of not less than six (6) years as from the date they became dormant”.")]), _vm._v(" "), _c('p', [_vm._v("On submission of this form, your user account will be removed and your personal information will be ‘archived’ making it inaccessible via the LogBox\n        system and unsubscribing from all email communication to your email address")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('submit-button', {
    attrs: {
      "loading": _vm.loadingRequest
    }
  }, [_vm._v("Submit Request")])], 1) : _c('div', {
    staticClass: "content h5"
  }, [_vm._v("\n      PLEASE NOTE:"), _c('br'), _c('br'), _vm._v("\n      Requests for the removal of patient account details can be done via the "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics"
    }
  }, [_vm._v("LogBox Patient application")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n      Please download the application from the "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=logbox.co.za.unified_demographics"
    }
  }, [_vm._v("Google play")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/za/app/logbox-patient/id1101708807"
    }
  }, [_vm._v("Apple store")]), _vm._v(" and submit a request using the account settings."), _c('br'), _c('br')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Patient-Icon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Delete your profile")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 primary"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate slow-large-refresh-animate"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c82183b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/RequestRemoval.vue
// module id = 661
// module chunks = 5